import { Brand } from '../branded-types';
import { z } from 'zod/v4';

export type InstituteData = {
  bic: BicString;
  creditInstitute: CreditInstituteString;
  city: string;
};

export interface IInstitutionData {
  bic: BicString;
  creditInstitute: CreditInstituteString;
}

export type BankDataId = Brand<string, 'configurationId'>;
export type IbanString = Brand<string, 'iban'>;
export type BicString = Brand<string, 'bic'>;
export type CreditInstituteString = Brand<string, 'creditInstitute'>;

export interface IIbanAllowed {
  isIbanAllowed: boolean;
}

export interface IIbanValidation {
  isIbanForbidden: boolean;
}

export interface IBankData {
  id?: BankDataId;
  firstName: string;
  lastName: string;
  iban: IbanString;
  bic: BicString;
  creditInstitute: CreditInstituteString;
}

export interface ICreateBankData {
  firstName: string;
  lastName: string;
  iban: IbanString;
  bic: BicString;
  creditInstitute: CreditInstituteString;
}

export const IBAN_ALLOWED_SCHEMA: z.ZodType<IIbanAllowed> = z.object({
  isIbanAllowed: z.boolean(),
});

export const IBAN_VALIDATION_SCHEMA: z.ZodType<IIbanValidation> = z.object({
  isIbanForbidden: z.boolean(),
});

export const BANK_DATA_SCHEMA: z.ZodType<IBankData> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as BankDataId)
    .optional(),
  firstName: z.string(),
  lastName: z.string(),
  iban: z.transform((s: string) => s as IbanString),
  bic: z.transform((s: string) => s as BicString),
  creditInstitute: z.transform((s: string) => s as CreditInstituteString),
});

export const BANK_DATA_ARRAY_SCHEMA: z.ZodType<IBankData[]> =
  z.array(BANK_DATA_SCHEMA);

export const INSTITUTION_DATA_SCHEMA: z.ZodType<IInstitutionData> = z.object({
  bic: z.transform((s: string) => s as BicString),
  creditInstitute: z.transform((s: string) => s as CreditInstituteString),
});
